import Text from "./Text";

function HeadingMedium(props) {
  return <Text {...props} />;
}

HeadingMedium.defaultProps = {
  as: "h2",
  fontWeight: 700,
  fontSize: [20, 20, 22, 22],
  lineHeight: 1.6,
  fontFamily: "bold",
};

export default HeadingMedium;
